export function getValueFromHashParam(hashName) {
  const hashSearchRegex = new RegExp("&?" + hashName + "=\\w+");

  const hash = window.location.hash;

  const listOfHashParams = hash.slice(1, hash.length).split("&");

  const hashIndex = listOfHashParams.findIndex((el) => {
    return hashSearchRegex.test(el);
  });

  if (hashIndex >= 0) {
    const paramArr = listOfHashParams[hashIndex].split("=");

    return paramArr[1];
  } else {
    return undefined;
  }
}

export function setHashParam(hashName, hashValue) {
  let hash = window.location.hash;

  const storyHashStartIndex = hash.search(hashName);

  if (storyHashStartIndex < 0) {
    if (hash.length <= 1) {
      hash = "#" + `${hashName}=${hashValue}`;
    } else {
      hash += "&" + `${hashName}=${hashValue}`;
    }
  } else {
    const storyHashEndIndex =
      hash.slice(storyHashStartIndex, hash.length).split("&")[0].length +
      storyHashStartIndex;

    const hashLeftPart = hash.slice(0, storyHashStartIndex);
    const hashRightPart = hash.slice(storyHashEndIndex, hash.length);

    hash = hashLeftPart + `${hashName}=${hashValue}` + hashRightPart;
  }

  hash = hash === "#" ? "" : hash;

  window.history.replaceState(
    {},
    "",
    window.location.href.split("#")[0] + hash
  );
}

export function deleteParamFromHash(hashName) {
  let hash = window.location.hash;

  const storyHashStartIndex = hash.search(hashName);
  if (storyHashStartIndex < 0) {
    return;
  }

  let hasAmpersandSymbol = false;
  if (hash[storyHashStartIndex - 1] === "&") {
    hasAmpersandSymbol = true;
  }

  const storyHashEndIndex =
    hash.slice(storyHashStartIndex, hash.length).split("&")[0].length +
    storyHashStartIndex +
    Number(!hasAmpersandSymbol);

  const hashLeftPart = hash.slice(
    0,
    storyHashStartIndex - Number(hasAmpersandSymbol)
  );
  const hashRightPart = hash.slice(storyHashEndIndex, hash.length);

  hash = hashLeftPart + hashRightPart;

  hash = hash === "#" ? "" : hash;

  window.history.replaceState(
    {},
    "",
    window.location.href.split("#")[0] + hash
  );
}
